/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/documentations",
    },
    (router) => {
      router.push({
        id: "@api/hotel.documentation@search",
        path: "",
      });

      router.group(
        {
          path: "/:hotelDocumentationId",
        },
        (router) => {
          router.push({
            id: "@api/hotel.documentation@show",
            path: "",
          });

          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel.documentation@download",
                path: "/download",
              });
            },
          );
        },
      );
    },
  );
}
